/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPricingsIndividualHealthQuery = gql`
  query GetSimulationPricingsIndividualHealthQuery {
    getSimulationPricingsIndividualHealth_simulation_pricings_individual_health {
      packs {
 packCode  
customerId  
granteeId  
pricings {
 moduleCode  
moduleLabel  
supplementaryCovers {
 moduleCode  
moduleLabel  
isPreSelected  
isRecommended  
supplementarySelectionMode  
prices {
 defaultPrice  
commission  
initialPrice  
startDateDisplayedPrice  
priceExternalCode  
} 
recommendedOptionMessage  
} 
isRecommended  
isPreSelected  
prices {
 defaultPrice  
commission  
initialPrice  
startDateDisplayedPrice  
priceExternalCode  
} 
supplementarySelectionMode  
recommendedProductMessage  
} 
commission {
 rates {
 label  
value  
} 
defaultRate  
rate  
} 
externalId  
externalCode  
groupCodes  
defaultGroupCode  
}
      error 
    }
  }
`;

export default GetSimulationPricingsIndividualHealthQuery;
